






































import { Vue, Component, Prop } from 'vue-property-decorator'
import Breadcrumbs from '@/components/Breadcrumbs.vue'
import VueMarkdown from 'vue-markdown'

type Link = {
  title: string
  links: {
    label: string
    to: {
      name: string
      params: object
      [key: string]: any
    }
  }[]
}

@Component({
  components: {
    VueMarkdown,
    Breadcrumbs,
  },
})
export default class ArticleView extends Vue {
  
  @Prop(String) title!: string
  @Prop(String) description?: string
  @Prop(String) authorName?: string
  @Prop(String) authorImage?: string
  @Prop(String) image?: string
  @Prop(String) date?: string
  @Prop(Object) previousRoute!: any
  @Prop(Array) body!: any[]
  @Prop(Array) links!: Link[]

  get breadcrumbs() {
    return [
      {to: this.previousRoute, text: this.previousRoute?.name},
      {text: this.title}
    ]
  }
}
